const startPiralDomain = "https://piral.";
const startOliveTeamDomain = 'olive-team.com';

export function getSubdomain() {
  const url = location.href;
  let domain = url.substring(startPiralDomain.length)
  domain = domain.substring(0, domain.indexOf(startOliveTeamDomain));
  return domain;
}